export function getFireLoc(languageCode: string) {
  return languageCode.replace(/_/g, '-');
}
